export enum StepperTypesEnum {
  ADDRESS = 0,
  PAYMENT,
  REVIEW_ORDER,
  DONE,
}

export enum StepNameEnum {
  AUTHORIZE = 'Authorize',
  ADDRESS = 'Address',
  PAYMENT = 'Payment',
  REVIEW_ORDER = 'Review Order',
}
